export default __webpack_public_path__ + "static/media/play.e5bbf681.png";